// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"81df9afe","310":"317ffe32","513":"57909d32","655":"0b8b2133","706":"2a332fbc"}[chunkId] + ".chunk.js";
};